import { Clock, TrendingUp } from "lucide-react";

const ExtendedHoursCTA = () => {
  return (
    <section className="py-20 md:py-28 px-6 bg-muted/40">
      <div className="container mx-auto">
        <div className="max-w-5xl mx-auto">
          <div className="text-center mb-12">
            <p className="text-sm font-semibold text-accent uppercase tracking-wide mb-3">
              Extended hours
            </p>
            <h2 className="text-3xl md:text-4xl font-bold mb-4 text-balance">
              The best moves happen when most traders are offline
            </h2>
            <p className="text-lg text-muted-foreground max-w-2xl mx-auto">
              Earnings drops, news breaks, institutional positioning—it all happens 
              outside regular hours. We watch so you don't have to.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-6">
            <div className="bg-card border border-border rounded-xl p-6 md:p-8">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
                  <Clock className="w-5 h-5 text-primary" />
                </div>
                <h3 className="text-xl font-semibold">Pre-market</h3>
              </div>
              <p className="text-muted-foreground mb-4">
                4:00 AM – 9:30 AM ET. Catch the early volatility before the opening bell.
              </p>
              <ul className="space-y-2 text-sm text-muted-foreground">
                <li className="flex items-center gap-2">
                  <div className="w-1 h-1 rounded-full bg-accent"></div>
                  <span>Overnight news reactions</span>
                </li>
                <li className="flex items-center gap-2">
                  <div className="w-1 h-1 rounded-full bg-accent"></div>
                  <span>European market spillover</span>
                </li>
                <li className="flex items-center gap-2">
                  <div className="w-1 h-1 rounded-full bg-accent"></div>
                  <span>Pre-market gap plays</span>
                </li>
              </ul>
            </div>

            <div className="bg-card border border-border rounded-xl p-6 md:p-8">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 bg-accent/10 rounded-lg flex items-center justify-center">
                  <TrendingUp className="w-5 h-5 text-accent" />
                </div>
                <h3 className="text-xl font-semibold">After-hours</h3>
              </div>
              <p className="text-muted-foreground mb-4">
                4:00 PM – 8:00 PM ET. Earnings season is when real money gets made.
              </p>
              <ul className="space-y-2 text-sm text-muted-foreground">
                <li className="flex items-center gap-2">
                  <div className="w-1 h-1 rounded-full bg-accent"></div>
                  <span>Earnings beat/miss alerts</span>
                </li>
                <li className="flex items-center gap-2">
                  <div className="w-1 h-1 rounded-full bg-accent"></div>
                  <span>After-hours volume spikes</span>
                </li>
                <li className="flex items-center gap-2">
                  <div className="w-1 h-1 rounded-full bg-accent"></div>
                  <span>Late-breaking news plays</span>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default ExtendedHoursCTA;